import React, { Component, createRef } from 'react';
import Router from 'next/router';
import { logout } from '../../../lib/logout';
import commonFunction from '../../../lib/utils/common';


class Menu extends Component {
  constructor(props) {
    super(props);
    this.menusWrapper = createRef();
    this.state = {
      hamburgerOpen: this.props.isopen
    }

  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  handleClickOutside = event => {
    if (this.menusWrapper.current && !this.menusWrapper.current.contains(event.target)) {
      this.props.closeMenusHandler(false)
    }
  }

  toggleHamburger = () => {
    this.setState({ hamburgerOpen: !this.state.hamburgerOpen })
  }

  onClickRedirect = (data, index) => {
    console.log("data.href", data.href);
    // Router.push({
    //   pathname: '/myprofile',
    //   query: `menu=${data.href}`,
    if (data.href == 'Logout') {
      this.props.onclickLogout()
    } else {
      this.props.clickedTab(index)
      window.location.href = `/myprofile?Linkindex=${index}`
    }
    // })

  }

  onClickProfile = () => {
    this.props.clickedTab(0)
    commonFunction.redirectTo('/myprofile')
  }
  onClickLogout = () => {
    logout().then((responseJSON) => {
      if (responseJSON.status === true || responseJSON.message === "Logout successfull") {
        this.setState({
          userFirststname: "",
          userType: ""
        })
        location.reload()
        commonFunction.redirectTo('/')
    
      } else {
      }
    }).catch(err => {
      console.log("errrrrrrrrrrr", err);
    })
  }

  myBookingClickHandler = () => {
    
    this.props.clickedTab(1)
    window.location.href = `/myprofile?Linkindex=1`
    // commonFunction.redirectTo('/myprofile', { Linkindex: 1 })
    
  }
 // Handler for Guest & Traveler
guestTravelerClickHandler = () => {
  this.props.clickedTab(9); // Linkindex for Guest & Traveler
  window.location.href = `/myprofile?Linkindex=9`;
}

// Handler for Travel Preferences
travelPreferencesClickHandler = () => {
  this.props.clickedTab(10); // Linkindex for Travel Preferences
  window.location.href = `/myprofile?Linkindex=10`;
}

  render() {
    // console.log("=========================>", this.props);
    return (
      <>
        {this.props.isopen &&
          <div ref={this.menusWrapper} className={this.props.styles.navigation_ineline}>
            <span className={this.props.styles.navigation_close}>
            <img
                  src="images/eth_user_login_Icon.svg"
                  alt="close"
                  onClick={() => this.props.closeMenusHandler(false)}
                />
            </span>
            {this.props.pathname === "/myprofile" ?
              this.props.MenuList.length > 0 && this.props.MenuList.map((element, index) => {
                return (
                  <div className={this.props.styles.mob_brd} key={"menulist" + index} onClick={() => { this.onClickRedirect(element, index) }}>
                    <div className={this.props.styles.mobile_sidenav}>
                      <span className={`${this.props.styles.my_settings_section_card_icon} ${this.props.styles.bui_u_margin8}`}><img src={element.imgInActiveSrc} alt={'imapo'} width="20" height="20" /> </span>
                      <a id="myprofile" role="button" className={this.props.styles.menu_item}  >{element.linkItem}</a>
                    </div>
                  </div>
                )
              }) : <div className={this.props?.styles?.afterlogin}> <span className={this.props?.styles?.user_code}>{this.state.userFirststname}</span>
                <div className={this.props?.styles?.profile_frst}>
                  <span onClick={this.onClickProfile} className={this.props?.styles?.menu_main_box}> <div className={this.props?.styles?.menu_icon}><img type="image" src="/images/eth_profile.svg" alt="profile" /></div>My Profile</span>
                  <span onClick={this.myBookingClickHandler} className={this.props?.styles?.menu_main_box}> <div className={this.props?.styles?.menu_icon}><img type="image" src="/images/eth_my_booking.svg" alt="mybooking" /></div>My Bookings</span>
                  <span onClick={this.guestTravelerClickHandler} className={this.props?.styles?.menu_main_box}> <div className={this.props?.styles?.menu_icon}><img type="image" src="/images/eth_guest_travel.svg" alt="mybooking" /></div>Guest & Traveler</span>
                  <span onClick={this.travelPreferencesClickHandler} className={this.props?.styles?.menu_main_box}> <div className={this.props?.styles?.menu_icon}><img type="image" src="/images/eth_travel_prefer.svg" alt="mybooking" /></div>Travel Preferences</span>
                  <span onClick={this.onClickLogout} className={this.props?.styles?.menu_main_box}> <div className={this.props?.styles?.menu_icon}><img type="image" src="/images/eth__logout.svg" alt="Logout" /></div>Logout</span>
                </div>
              </div>
            }
          </div>
        }
      </>
    )
  }
}

export default Menu;
